<div class="uploads-history-container">
  <div class="table-header">
    <h1>{{ 'upload.history.title' | translate }}</h1>
    <div class="line-part"></div>
  </div>

  <qs-table
    testId="upload-history"
    [data]="data"
    [columns]="columns"
    [isPaginatorEnabled]="true"
    [paginatorConfig]="paginatorConfig"
    [columnFilterConfig]="columnFilterConfig"
  >
  </qs-table>
</div>

<ng-template #statusTemplate let-row>
  <div class="status-cell">
    <span class="status-indicator" [ngClass]="row.status || ''"></span>
    <span class="red">
      {{ 'upload.history.status.' + row.status | translate }}
    </span>
    <time
      *ngIf="row.processingUpdatedAt"
      class="processing-updated"
      [attr.datetime]="row.processingUpdatedAt"
      [title]="formatTime(row.processingUpdatedAt)"
    >
      {{
        'upload.history.updated'
          | translate: { time: formatTimeAgo(row.processingUpdatedAt) }
      }}
    </time>
  </div>
</ng-template>
<ng-template #artifactTemplate let-row>
  <a
    class="artifact"
    *ngIf="row.device"
    href="/device/{{ row.device?.deviceId }}"
    >{{ getDeviceName(row.device) }}</a
  >
</ng-template>
